import { API } from "@aws-amplify/api";
import { API_STRIPE } from "../../constants";

const stripeAPI = API_STRIPE;
const capePath = "/stripecancelatendofperiod";


export async function setCancelAtEndOfPeriod(status, subscriptionid) {
    try {
      await API.put(stripeAPI, capePath, {
        queryStringParameters: {
          cancelatendofperiod: status,
          subscriptionid: subscriptionid,
        },
      });
    } catch (error) {
      console.error("Failed to update subscription", {
        error: error.message,
        subscriptionId: subscriptionid
      });
    }
  }